<template>
  <div>
    <template v-for="dialog in dialogs">
      <v-dialog :key="dialog.id" @input="select(dialog, null)" :persistent="dialog.persistent" :value="dialog.visible" max-width="360" @keydown.esc="select(dialog, false)" data-testid="v-dialog_62434cf2-815b-4045-902b-72780e8d20d5">
        <v-card tile data-testid="v-card_936a584f-ffcb-47ec-99fa-c9943aa7a051" :class="{'pt-4' : dialog.title == null}">
          <v-card-title v-if="dialog.title != null" class="wordBreak" v-text="dialog.title"></v-card-title>
          <v-card-text v-if="dialog.message != null" class="lineBreaks" v-text="dialog.message"/>
          <v-card-text v-if="dialog.trusted_html != null" v-html="dialog.trusted_html"/>
          <v-card-actions>
            <v-spacer/>
            <v-btn v-if="dialog.type === 'alert'" color="primary" @click="select(dialog, true)" data-testid="v-btn_66e74e94-a5f3-43ff-8f34-edf6b2f75df9">{{ $t('ok') }}</v-btn>
            <v-btn v-if="dialog.type === 'confirm'" :color="dialog.positiveColor" @click="select(dialog, true)" data-testid="v-btn_cb673743-37e7-4279-89fc-23dbec07be17">{{ dialog.positiveText }}</v-btn>
            <v-btn v-if="dialog.type === 'confirm'" :color="dialog.negativeColor" text @click="select(dialog, false)" data-testid="v-btn_44f649ec-44b2-4b2e-8c76-18503a8d327e">{{ dialog.negativeText }}</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </template>
  </div>
</template>

<script>
import utils from 'reactor-js-core/dist/utils.js'

export default {
  data () {
    return {
      value: false,
      dialogs: []
    }
  },
  methods: {
    select(dialog, value) {
      if (dialog.callback) {
        dialog.callback(value);
      }
      this.dialogs = this.dialogs.filter(d => { return d.id != dialog.id; });
    },
    confirm(message, callback) {
      var dialog = {
        type: 'confirm',
        id: utils.uuidv4(),
        message: message,
        positiveText: this.$t('yes'),
        negativeText: this.$t('no'),
        positiveColor: "primary",
        negativeColor: "primary",
        callback: callback,
        visible: true,
        persistent: false,
      }
      dialog.dismiss = (value) => {
        this.select(dialog, value);
      }
      if (message.title != null) dialog.title = message.title;
      if (message.message != null) dialog.message = message.message;
      if (message.positiveText != null) dialog.positiveText = message.positiveText;
      if (message.negativeText != null) dialog.negativeText = message.negativeText;
      if (message.persistent != null) dialog.persistent = message.persistent;
      if (message.positiveColor != null) dialog.positiveColor = message.positiveColor;
      if (message.negativeColor != null) dialog.negativeColor = message.negativeColor;
      if (message.trusted_html != null) {
        dialog.trusted_html = message.trusted_html;
        if (message.message == null) dialog.message = null;
      }
      this.dialogs.push(dialog);
      return dialog;
    },
    alert(message, callback) {
      var dialog = {
        type: 'alert',
        id: utils.uuidv4(),
        message: message,
        callback: callback,
        visible: true,
        persistent: true
      };
      if (message.title != null) dialog.title = message.title;
      if (message.message != null) dialog.message = message.message;
      if (message.trusted_html != null) {
        dialog.message = null;
        dialog.trusted_html = message.trusted_html;
      }
      dialog.dismiss = (value) => {
        this.select(dialog, value);
      }
      this.dialogs.push(dialog);
      return dialog;
    }
  }
}
</script>

<style scoped lang="scss">
.theme--light.v-card>.v-card__text {
  color: rgba(0,0,0,.87);
}
.wordBreak {
  word-break: break-word;
}
.lineBreaks {
  white-space: pre-line;
}
</style>


// WEBPACK FOOTER //
// src/components/ConfirmDialog.vue